// @ts-check
// =============================================================================
// js/app/shell-mode.js — is this page load a portal shell (itch, Newgrounds…)?
//
// THE CONTRACT (supersedes the earlier embedded-mode.js)
//   A shell is any wrapper that hosts the game somewhere account flows can't
//   work: OAuth refuses to render framed, and a same-window redirect would
//   strand the wrapper. Shell play is GUEST-ONLY bot play; online-play
//   affordances stay visible but open the "Play Online" pitch instead
//   (ui/upsell.js), and Join/Patreon links open a real browser tab.
//
//   Shells COMMUNICATE via the URL: every wrapper under portals/ bakes
//   ?portal=<name> into its iframe src. That explicit signal wins over frame
//   sniffing — it also covers portals that launch the game in a POPUP
//   window, where self===top and frame detection is blind. The name sticks
//   in sessionStorage so the mode survives in-tab reloads, and an unbadged
//   iframe still counts via the self/top check ('embedded').
//
//   A leaf module (no imports) so session/splash/nav/upsell/analytics can
//   all ask without cycles — same pattern as quickplay-mode.js.
// =============================================================================

/** sessionStorage key for the sticky portal name. */
const PORTAL_KEY = 'shellPortal';

/** Framed? The self/top comparison is safe cross-origin; an exotic sandbox
 *  that throws on it is, by definition, embedded. */
function framed() {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
}

/**
 * Which shell is hosting us?
 *   '<portal>'  — a ?portal=<name> wrapper (sanitized, lowercased, sticky
 *                 for the tab via sessionStorage),
 *   'embedded'  — framed without a portal badge,
 *   null        — not a shell (normal top-level visit).
 * @returns {string|null}
 */
export function shellPortal() {
	try {
		const raw = new URLSearchParams(window.location.search).get('portal');
		const clean = raw ? raw.replace(/[^a-zA-Z0-9]/g, '').slice(0, 24).toLowerCase() : '';
		if (clean) {
			try {
				sessionStorage.setItem(PORTAL_KEY, clean);
			} catch {
				// storage refused — the param itself still carries the mode
			}
			return clean;
		}
		const stored = sessionStorage.getItem(PORTAL_KEY);
		if (stored) return stored;
	} catch {
		// unparseable URL / blocked storage — fall through to frame sniffing
	}
	return framed() ? 'embedded' : null;
}

/**
 * Is the game running inside a portal shell (badged or plain iframe)?
 * @returns {boolean}
 */
export function isShell() {
	return shellPortal() !== null;
}

/**
 * Open the full game site in a REAL browser tab (out of the shell). Uses our
 * own origin, so the dev instance hands off to dev and live hands off to live.
 * @returns {void}
 */
export function openFullSiteTab() {
	window.open(window.location.origin, '_blank', 'noopener');
}
